import {
    ELUSIVEDATA_SET,
    ELUSIVEDATA_UNSET,
    ELUSIVEDATA_CLEAR,
    ELUSIVEDATA_CLEAR_SUBPANELS,
    ELUSIVEDATA_CLEAR_ALL
} from '~/frontend/src/constants';
import {
    SetElusiveDataAction,
    UnsetElusiveDataAction,
    ClearElusiveDataAction,
    ClearElusiveDataForSubpanelsAction,
    ElusiveData,
    ClearAllElusiveDataAction
} from '~/frontend/src/actions/elusiveData';

export type PanelElusiveDataState = Partial<ElusiveData>;

type Action =
    SetElusiveDataAction
    | UnsetElusiveDataAction
    | ClearElusiveDataAction
    | ClearAllElusiveDataAction
    | ClearElusiveDataForSubpanelsAction;

export type ElusiveDataState = Partial<{
    [ panelKey : string ] : PanelElusiveDataState;
}>;

const relevantActions = [
    ELUSIVEDATA_SET,
    ELUSIVEDATA_UNSET,
    ELUSIVEDATA_CLEAR,
    ELUSIVEDATA_CLEAR_ALL,
    ELUSIVEDATA_CLEAR_SUBPANELS
];

/**
 *
 * @param state
 * @param action
 */
export default function elusiveDataReducer( state : ElusiveDataState = {}, action : Action ) : ElusiveDataState {
    let changed = false,
        clear   = false;

    if ( relevantActions.includes( action.type ) ) {

        // special handling actions
        if ( action.type === ELUSIVEDATA_CLEAR_ALL ) {
            state = {};
        }
        else if ( action.type === ELUSIVEDATA_CLEAR_SUBPANELS ) {
            const { panelKey }    = action,
                  elusiveDataKeys = Object.keys( state ) as string[];

            for ( const elusiveDataKey of elusiveDataKeys ) {
                if ( elusiveDataKey.match( `^${panelKey}[_-](.*)$` ) ) {
                    changed = true;

                    delete state[ elusiveDataKey ];
                }
            }

            if ( changed ) {
                // copy current (stay immutable - but only for the outer state)
                state = { ...state };
            }
        }

        // other actions
        else {
            const { panelKey } = action;

            let panelElusiveData : PanelElusiveDataState = {},
                data : any,
                dataKeys : string[],
                keys : string[];

            if ( state[ panelKey ] ) {
                // copy current (stay immutable!)
                panelElusiveData = { ...state[ panelKey ] };
            }

            switch ( action.type ) {
                case ELUSIVEDATA_SET:
                    ( { data } = action );

                    dataKeys = Object.keys( data ) as string[];

                    for ( const dataKey of dataKeys ) {
                        if (
                            panelElusiveData[ dataKey ] === undefined
                        ) {
                            changed = true;

                            panelElusiveData[ dataKey ] = data[ dataKey ];
                        }
                        else {
                            let dataChanged : boolean | undefined;

                            try {
                                dataChanged = JSON.stringify( panelElusiveData[ dataKey ] ) !== JSON.stringify( data[ dataKey ] );
                            }
                            catch ( e ) {
                                // ignore silently
                            }

                            if ( dataChanged === undefined ) {
                                dataChanged = panelElusiveData[ dataKey ] !== data[ dataKey ];
                            }

                            if ( dataChanged ) {
                                changed = true;

                                panelElusiveData[ dataKey ] = data[ dataKey ];
                            }
                        }
                    }

                    break;

                case ELUSIVEDATA_UNSET:
                    ( { keys } = action );

                    for ( const dataKey of keys ) {
                        if ( panelElusiveData[ dataKey ] !== undefined ) {
                            changed = true;

                            delete panelElusiveData[ dataKey ];
                        }
                    }

                    break;

                case ELUSIVEDATA_CLEAR:
                    clear = true;

                    break;
            }

            if ( changed || ( clear && state[ panelKey ] ) ) {
                // copy current (stay immutable - but only for the outer state)
                state = { ...state };

                if ( !clear ) {
                    state[ panelKey ] = panelElusiveData;
                }
                else {
                    delete state[ panelKey ];
                }
            }
        }
    }

    return state;
}
